/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddAddressRequest {
    /** @minLength 1 */
    provinceId: string
    /** @minLength 1 */
    cityId: string
    useAnotherRecipient?: boolean
    receiverName?: string | null
    receiverMobileNumber?: string | null
    /** @minLength 1 */
    descriptions: string
    /** @minLength 1 */
    plate: string
    unit?: string | null
    /** @minLength 1 */
    postalCode: string
    /**
     * @format double
     * @min 25
     * @max 40
     */
    latitude?: number | null
    /**
     * @format double
     * @min 40
     * @max 65
     */
    longitude?: number | null
}

export interface AddressSearchViewModel {
    geoLocationTitle?: string
    description?: string
    /** @format double */
    latitude?: number
    /** @format double */
    longitude?: number
}

export interface AddressSearchViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: AddressSearchViewModel[] | null
}

export interface AddressViewModel {
    id?: string
    province?: ProvinceViewModel
    city?: CityViewModel
    useAnotherRecipient?: boolean
    receiverName?: string
    receiverMobileNumber?: string
    descriptions?: string
    postalCode?: string
    /** @format double */
    latitude?: number | null
    /** @format double */
    longitude?: number | null
    plate?: string | null
    unit?: string | null
}

export interface AddressViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: AddressViewModel[] | null
}

export interface AddressViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: AddressViewModel
}

export interface AssignRoleGroupToUserRequest {
    roleGroupIds?: string[]
}

export interface AssignRoleToRoleGroupRequest {
    roleIds?: string[]
}

export interface AssignRoleToUserRequest {
    roleIds?: string[]
}

export interface CityViewModel {
    id?: string
    name?: string
    /** @format double */
    latitude?: number | null
    /** @format double */
    longitude?: number | null
    useGeolocation?: boolean
}

export interface CityViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: CityViewModel[] | null
}

export interface CreateEmployeeRequest {
    /**
     * @minLength 3
     * @maxLength 32
     * @pattern [A-Za-z0-9._\-@]+
     */
    username: string
    /**
     * @minLength 2
     * @maxLength 36
     */
    firstName?: string | null
    /**
     * @minLength 2
     * @maxLength 36
     */
    lastName?: string | null
    /**
     * @minLength 6
     * @maxLength 96
     */
    emailAddress?: string | null
    isActive?: boolean
    gender?: GenderType
    /** @minLength 1 */
    mobileNumber: string
    /**
     * @minLength 6
     * @maxLength 20
     */
    password: string
}

export interface CreateRoleGroupRequest {
    /**
     * @minLength 1
     * @maxLength 128
     */
    name: string
}

export interface CreateRoleGroupViewModel {
    id?: string
    name?: string
}

export interface CreateRoleGroupViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: CreateRoleGroupViewModel
}

export interface CreateTicketRequest {
    /** @minLength 1 */
    description: string
    /** @format uri */
    productUrl: string
    /** @minLength 1 */
    productName: string
    /** @format uuid */
    ticketCategoryIdLevelOne: string
    /** @format uuid */
    ticketCategoryIdLevelTwo: string
    /** @format uuid */
    ticketCategoryIdLevelTree: string
    /** @format uuid */
    customerId: string
}

export interface EmployeeViewModel {
    userId?: string
    mobileNumber?: string
    username?: string
    firstName?: string | null
    lastName?: string | null
    emailAddress?: string | null
    isActive?: boolean
    gender?: GenderType
    /** @format date-time */
    createdAt?: string
}

export interface EmployeeViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: EmployeeViewModel[]
}

export interface EmployeeViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: EmployeeViewModelPaginationViewModel
}

export interface EmployeeViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: EmployeeViewModel
}

export interface EnvelopError {
    code?: string
    message?: string
    property?: string | null
    attemptedValue?: any
    details?: string | null
}

export interface Error {
    code?: string | null
    message?: string | null
}

export interface FailureEnvelop {
    isSuccess?: boolean
    errors?: IEnvelopError[]
}

export enum GenderType {
    Female = 'Female',
    Male = 'Male',
}

export interface GetAdminUserViewModel {
    id?: string | null
    firstName?: string | null
    lastName?: string | null
    mobileNumber?: string | null
    emailAddress?: string | null
    roles?: RoleViewModel[]
    roleGroups?: RoleGroupViewModel[]
}

export interface GetAdminUserViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetAdminUserViewModel[]
}

export interface GetAdminUserViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetAdminUserViewModelPaginationViewModel
}

export interface GetAdminUserViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetAdminUserViewModel
}

export interface GetTicketCategoryListViewModel {
    /** @format uuid */
    categoryId?: string
    title?: string
}

export interface GetTicketCategoryListViewModelArraySuccessEnvelop {
    isSuccess?: boolean
    data?: GetTicketCategoryListViewModel[] | null
}

export interface GetUserReferralCodeViewModel {
    code?: string
}

export interface GetUserReferralCodeViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetUserReferralCodeViewModel
}

export interface GetUserViewModel {
    /** @format uuid */
    id?: string
    firstName?: string | null
    lastName?: string | null
    mobileNumber?: string | null
    emailAddress?: string | null
    gender?: GenderType
    /**
     * @deprecated
     * @format int32
     */
    sex?: number
    nationalCode?: string | null
    /** @format date */
    birthDate?: string | null
    userType?: UserType
    /** @format int32 */
    lastPurchaseDay?: number | null
    /** @format int32 */
    totalOrder?: number | null
    /** @format int64 */
    aov?: number | null
    lastAddressProvinceName?: string | null
    lastAddressCityName?: string | null
    foreignNationalCode?: string | null
    /** @format date-time */
    joinDate?: string | null
    /** @format int64 */
    walletAmount?: number
    lastOrderCategory?: string
    lrfmCategory?: string | null
    registrationStatus?: RegistrationStatus
}

export interface GetUserViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetUserViewModel
}

export interface IEnvelopError {
    code?: string
    message?: string
    property?: string | null
    attemptedValue?: any
    details?: string | null
}

export interface LocationAddressSearchViewModel {
    address?: string
    subDivisionPrefix?: string
}

export interface LocationAddressSearchViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: LocationAddressSearchViewModel
}

export interface ProvinceViewModel {
    id?: string
    name?: string
    /** @format double */
    latitude?: number | null
    /** @format double */
    longitude?: number | null
}

export interface ProvinceViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: ProvinceViewModel[] | null
}

export enum RegistrationStatus {
    NewUser = 'NewUser',
    RegisteredUser = 'RegisteredUser',
}

export interface ResetEmployeePasswordRequest {
    /**
     * @minLength 6
     * @maxLength 20
     */
    password?: string
}

export interface RoleGroupViewModel {
    id?: string
    name?: string
    roles?: RoleViewModel[]
    /** @format date-time */
    createdAt?: string
    /** @format date-time */
    updatedAt?: string
}

export interface RoleGroupViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: RoleGroupViewModel[]
}

export interface RoleGroupViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: RoleGroupViewModelPaginationViewModel
}

export interface RoleViewModel {
    id?: string
    name?: string
}

export interface RoleViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: RoleViewModel[]
}

export interface RoleViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: RoleViewModelPaginationViewModel
}

export interface StringSuccessEnvelop {
    isSuccess?: boolean
    data?: string | null
}

export interface SuccessEnvelop {
    isSuccess?: boolean
    data?: any
}

export interface UpdateAddressRequest {
    /** @minLength 1 */
    provinceId: string
    /** @minLength 1 */
    cityId: string
    useAnotherRecipient?: boolean
    receiverName?: string | null
    receiverMobileNumber?: string | null
    /** @minLength 1 */
    descriptions: string
    /** @minLength 1 */
    plate: string
    unit?: string | null
    /** @minLength 1 */
    postalCode: string
    /**
     * @format double
     * @min 25
     * @max 40
     */
    latitude?: number | null
    /**
     * @format double
     * @min 40
     * @max 65
     */
    longitude?: number | null
}

export interface UpdateEmployeeRequest {
    /**
     * @minLength 3
     * @maxLength 32
     * @pattern [A-Za-z0-9._\-@]+
     */
    username: string
    /**
     * @minLength 2
     * @maxLength 36
     */
    firstName?: string | null
    /**
     * @minLength 2
     * @maxLength 36
     */
    lastName?: string | null
    /**
     * @minLength 6
     * @maxLength 96
     */
    emailAddress?: string | null
    isActive?: boolean
    gender?: GenderType
}

export interface UpdateRoleGroupRequest {
    /**
     * @minLength 1
     * @maxLength 128
     */
    name: string
}

export interface UpdateRoleGroupViewModel {
    id?: string
    name?: string
}

export interface UpdateRoleGroupViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: UpdateRoleGroupViewModel
}

export interface UpdateUserRequest {
    /** @minLength 1 */
    firstName: string
    /** @minLength 1 */
    lastName: string
    emailAddress?: string | null
    /**
     * @deprecated
     * @format int32
     */
    sex?: number | null
    gender?: GenderType
    nationalCode?: string | null
    foreignNationalCode?: string | null
    /** @format date */
    birthDate?: string | null
}

export enum UserType {
    New = 'New',
    Returning = 'Returning',
}

export interface ValidateLocationViewModel {
    isAcceptable?: boolean
    isValid?: boolean
    /** @format int32 */
    distanceMeter?: number | null
    sameStreet?: boolean | null
    samePlate?: boolean | null
    sameUnit?: boolean | null
    /** @format int32 */
    certainty?: number | null
    cityId?: string
    /** @format double */
    latitude?: number
    /** @format double */
    longitude?: number
    address?: string
    error?: Error
}

export interface ValidateLocationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ValidateLocationViewModel
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean
    /** request path */
    path: string
    /** content type of request body */
    type?: ContentType
    /** query params */
    query?: QueryParamsType
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat
    /** request body */
    body?: unknown
    /** base url */
    baseUrl?: string
    /** request cancellation token */
    cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
    customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D
    error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = ''
    private securityData: SecurityDataType | null = null
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
    private abortControllers = new Map<CancelToken, AbortController>()
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    }

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig)
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data
    }

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key)
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key])
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key]
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {}
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
        return keys
            .map((key) =>
                Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)
            )
            .join('&')
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery)
        return queryString ? `?${queryString}` : ''
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key]
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`
                )
                return formData
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    }

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        }
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken)
            if (abortController) {
                return abortController.signal
            }
            return void 0
        }

        const abortController = new AbortController()
        this.abortControllers.set(cancelToken, abortController)
        return abortController.signal
    }

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken)

        if (abortController) {
            abortController.abort()
            this.abortControllers.delete(cancelToken)
        }
    }

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {}
        const requestParams = this.mergeRequestParams(params, secureParams)
        const queryString = query && this.toQueryString(query)
        const payloadFormatter = this.contentFormatters[type || ContentType.Json]
        const responseFormat = format || requestParams.format

        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>
            r.data = null as unknown as T
            r.error = null as unknown as E

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data
                          } else {
                              r.error = data
                          }
                          return r
                      })
                      .catch((e) => {
                          r.error = e
                          return r
                      })

            if (cancelToken) {
                this.abortControllers.delete(cancelToken)
            }

            if (!response.ok) throw data
            return data
        })
    }
}

/**
 * @title Pam
 * @version v1
 *
 * Pam back-end (Web API)
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    api = {
        /**
         * No description
         *
         * @tags Account
         * @name PamVendorV1AccountsSsoCallbackList
         * @request GET:/api/pam/vendor/v1/accounts/sso-callback
         */
        pamVendorV1AccountsSsoCallbackList: (
            query?: {
                code?: string
                state?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/vendor/v1/accounts/sso-callback`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamVendorV1AccountsLogoutCreate
         * @request POST:/api/pam/vendor/v1/accounts/logout
         */
        pamVendorV1AccountsLogoutCreate: (params: RequestParams = {}) =>
            this.request<void, void>({
                path: `/api/pam/vendor/v1/accounts/logout`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamVendorV1AccountsLoginList
         * @request GET:/api/pam/vendor/v1/accounts/login
         */
        pamVendorV1AccountsLoginList: (
            query?: {
                redirectUrl?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/vendor/v1/accounts/login`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamLogisticV1AccountsSsoCallbackList
         * @request GET:/api/pam/logistic/v1/accounts/sso-callback
         */
        pamLogisticV1AccountsSsoCallbackList: (
            query?: {
                code?: string
                state?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/logistic/v1/accounts/sso-callback`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamLogisticV1AccountsLogoutCreate
         * @request POST:/api/pam/logistic/v1/accounts/logout
         */
        pamLogisticV1AccountsLogoutCreate: (params: RequestParams = {}) =>
            this.request<void, void>({
                path: `/api/pam/logistic/v1/accounts/logout`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamLogisticV1AccountsLoginList
         * @request GET:/api/pam/logistic/v1/accounts/login
         */
        pamLogisticV1AccountsLoginList: (
            query?: {
                redirectUrl?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/logistic/v1/accounts/login`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamDriverV1AccountsSsoCallbackList
         * @request GET:/api/pam/driver/v1/accounts/sso-callback
         */
        pamDriverV1AccountsSsoCallbackList: (
            query?: {
                code?: string
                state?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/driver/v1/accounts/sso-callback`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamDriverV1AccountsLogoutCreate
         * @request POST:/api/pam/driver/v1/accounts/logout
         */
        pamDriverV1AccountsLogoutCreate: (params: RequestParams = {}) =>
            this.request<void, void>({
                path: `/api/pam/driver/v1/accounts/logout`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamDriverV1AccountsLoginList
         * @request GET:/api/pam/driver/v1/accounts/login
         */
        pamDriverV1AccountsLoginList: (
            query?: {
                redirectUrl?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/driver/v1/accounts/login`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamAdminV1AccountsSsoCallbackList
         * @request GET:/api/pam/admin/v1/accounts/sso-callback
         */
        pamAdminV1AccountsSsoCallbackList: (
            query?: {
                code?: string
                state?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/admin/v1/accounts/sso-callback`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamAdminV1AccountsLogoutCreate
         * @request POST:/api/pam/admin/v1/accounts/logout
         */
        pamAdminV1AccountsLogoutCreate: (params: RequestParams = {}) =>
            this.request<void, void>({
                path: `/api/pam/admin/v1/accounts/logout`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamAdminV1AccountsLoginList
         * @request GET:/api/pam/admin/v1/accounts/login
         */
        pamAdminV1AccountsLoginList: (
            query?: {
                redirectUrl?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/admin/v1/accounts/login`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamV1AccountsSsoCallbackList
         * @request GET:/api/pam/v1/accounts/sso-callback
         */
        pamV1AccountsSsoCallbackList: (
            query?: {
                code?: string
                state?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/v1/accounts/sso-callback`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamV1AccountsLogoutCreate
         * @request POST:/api/pam/v1/accounts/logout
         */
        pamV1AccountsLogoutCreate: (params: RequestParams = {}) =>
            this.request<void, void>({
                path: `/api/pam/v1/accounts/logout`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Account
         * @name PamV1AccountsLoginList
         * @request GET:/api/pam/v1/accounts/login
         */
        pamV1AccountsLoginList: (
            query?: {
                redirectUrl?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<any, void>({
                path: `/api/pam/v1/accounts/login`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Address
         * @name PamV1AddressesLocationAddressSearchList
         * @request GET:/api/pam/v1/addresses/location-address-search
         */
        pamV1AddressesLocationAddressSearchList: (
            query: {
                /** @format double */
                latitude: number
                /** @format double */
                longitude: number
            },
            params: RequestParams = {}
        ) =>
            this.request<LocationAddressSearchViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/addresses/location-address-search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Address
         * @name PamV1AddressesAddressSearchList
         * @request GET:/api/pam/v1/addresses/address-search
         */
        pamV1AddressesAddressSearchList: (
            query: {
                search_text: string
                city_id: string
            },
            params: RequestParams = {}
        ) =>
            this.request<AddressSearchViewModelListSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/addresses/address-search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ContactUs
         * @name PamV1ContactUsCreate
         * @request POST:/api/pam/v1/contact-us
         */
        pamV1ContactUsCreate: (
            data: {
                Name: string
                MobileNumber: string
                Email?: string
                Message: string
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, EnvelopError>({
                path: `/api/pam/v1/contact-us`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Employee
         * @name PamAdminV1EmployeesIdUpdate
         * @request PUT:/api/pam/admin/v1/employees/id/{id}
         */
        pamAdminV1EmployeesIdUpdate: (id: string, data: UpdateEmployeeRequest, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/employees/id/${id}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Employee
         * @name PamAdminV1EmployeesIdPasswordUpdate
         * @request PUT:/api/pam/admin/v1/employees/id/{id}/password
         */
        pamAdminV1EmployeesIdPasswordUpdate: (
            id: string,
            data: ResetEmployeePasswordRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/employees/id/${id}/password`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Employee
         * @name PamAdminV1EmployeesList
         * @request GET:/api/pam/admin/v1/employees
         */
        pamAdminV1EmployeesList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EmployeeViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/employees`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Employee
         * @name PamAdminV1EmployeesCreate
         * @request POST:/api/pam/admin/v1/employees
         */
        pamAdminV1EmployeesCreate: (data: CreateEmployeeRequest, params: RequestParams = {}) =>
            this.request<EmployeeViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/employees`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Location
         * @name InternalV1LocationsLatLongValidateDetail
         * @request GET:/api/internal/v1/locations/lat/{latitude}/long/{longitude}/validate
         */
        internalV1LocationsLatLongValidateDetail: (
            latitude: number,
            longitude: number,
            query: {
                city_id: string
                /**
                 * @minLength 0
                 * @maxLength 512
                 */
                address: string
            },
            params: RequestParams = {}
        ) =>
            this.request<ValidateLocationViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/internal/v1/locations/lat/${latitude}/long/${longitude}/validate`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Province
         * @name PamV1ProvincesList
         * @request GET:/api/pam/v1/provinces
         */
        pamV1ProvincesList: (params: RequestParams = {}) =>
            this.request<ProvinceViewModelListSuccessEnvelop, any>({
                path: `/api/pam/v1/provinces`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Province
         * @name PamV1ProvincesIdCitiesDetail
         * @request GET:/api/pam/v1/provinces/id/{id}/cities
         */
        pamV1ProvincesIdCitiesDetail: (id: string, params: RequestParams = {}) =>
            this.request<CityViewModelListSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/provinces/id/${id}/cities`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags RateLimit
         * @name PamAdminV1RateLimitUnblockMobileCreate
         * @request POST:/api/pam/admin/v1/rate-limit-unblock/mobile
         */
        pamAdminV1RateLimitUnblockMobileCreate: (
            data: {
                mobileNumber: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/rate-limit-unblock/mobile`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags RateLimit
         * @name PamAdminV1RateLimitUnblockEmailCreate
         * @request POST:/api/pam/admin/v1/rate-limit-unblock/email
         */
        pamAdminV1RateLimitUnblockEmailCreate: (
            data: {
                email: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/rate-limit-unblock/email`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Role
         * @name PamAdminV1RolesList
         * @request GET:/api/pam/admin/v1/roles
         */
        pamAdminV1RolesList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<RoleViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/roles`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags RoleGroup
         * @name PamAdminV1RoleGroupsIdUpdate
         * @request PUT:/api/pam/admin/v1/role-groups/id/{id}
         */
        pamAdminV1RoleGroupsIdUpdate: (id: string, data: UpdateRoleGroupRequest, params: RequestParams = {}) =>
            this.request<UpdateRoleGroupViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/role-groups/id/${id}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags RoleGroup
         * @name PamAdminV1RoleGroupsIdDelete
         * @request DELETE:/api/pam/admin/v1/role-groups/id/{id}
         */
        pamAdminV1RoleGroupsIdDelete: (id: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/role-groups/id/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags RoleGroup
         * @name PamAdminV1RoleGroupsList
         * @request GET:/api/pam/admin/v1/role-groups
         */
        pamAdminV1RoleGroupsList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<RoleGroupViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/role-groups`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags RoleGroup
         * @name PamAdminV1RoleGroupsCreate
         * @request POST:/api/pam/admin/v1/role-groups
         */
        pamAdminV1RoleGroupsCreate: (data: CreateRoleGroupRequest, params: RequestParams = {}) =>
            this.request<CreateRoleGroupViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/role-groups`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags RoleGroup
         * @name PamAdminV1RoleGroupsIdRolesUpdate
         * @request PUT:/api/pam/admin/v1/role-groups/id/{id}/roles
         */
        pamAdminV1RoleGroupsIdRolesUpdate: (
            id: string,
            data: AssignRoleToRoleGroupRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/role-groups/id/${id}/roles`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Ticket
         * @name PamAdminV1TicketsCreate
         * @request POST:/api/pam/admin/v1/tickets
         */
        pamAdminV1TicketsCreate: (data: CreateTicketRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/tickets`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TicketCategory
         * @name PamAdminV1TicketCategoriesList
         * @request GET:/api/pam/admin/v1/ticket-categories
         */
        pamAdminV1TicketCategoriesList: (
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 3
                 */
                level?: number
                /** @format uuid */
                category_id?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<GetTicketCategoryListViewModelArraySuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/ticket-categories`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamVendorV1UsersCurrentList
         * @request GET:/api/pam/vendor/v1/users/_current
         */
        pamVendorV1UsersCurrentList: (params: RequestParams = {}) =>
            this.request<GetUserViewModelSuccessEnvelop, void>({
                path: `/api/pam/vendor/v1/users/_current`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentAddressesAddressIdValidateLocationDetail
         * @request GET:/api/pam/v1/users/_current/addresses/address-id/{address_id}/validate-location
         */
        pamV1UsersCurrentAddressesAddressIdValidateLocationDetail: (addressId: string, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop | void>({
                path: `/api/pam/v1/users/_current/addresses/address-id/${addressId}/validate-location`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentUpdate
         * @request PUT:/api/pam/v1/users/_current
         */
        pamV1UsersCurrentUpdate: (data: UpdateUserRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/users/_current`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentList
         * @request GET:/api/pam/v1/users/_current
         */
        pamV1UsersCurrentList: (params: RequestParams = {}) =>
            this.request<GetUserViewModelSuccessEnvelop, void>({
                path: `/api/pam/v1/users/_current`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentAddressesAddressIdUpdate
         * @request PUT:/api/pam/v1/users/_current/addresses/address-id/{address_id}
         */
        pamV1UsersCurrentAddressesAddressIdUpdate: (
            addressId: string,
            data: UpdateAddressRequest,
            query?: {
                ignoreLocationValidation?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/users/_current/addresses/address-id/${addressId}`,
                method: 'PUT',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentAddressesAddressIdDelete
         * @request DELETE:/api/pam/v1/users/_current/addresses/address-id/{address_id}
         */
        pamV1UsersCurrentAddressesAddressIdDelete: (addressId: string, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/users/_current/addresses/address-id/${addressId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentJwtList
         * @request GET:/api/pam/v1/users/_current/jwt
         */
        pamV1UsersCurrentJwtList: (params: RequestParams = {}) =>
            this.request<StringSuccessEnvelop, void>({
                path: `/api/pam/v1/users/_current/jwt`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentAddressesLastList
         * @request GET:/api/pam/v1/users/_current/addresses/last
         */
        pamV1UsersCurrentAddressesLastList: (params: RequestParams = {}) =>
            this.request<AddressViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/users/_current/addresses/last`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name GetAddressList
         * @request GET:/api/pam/v1/users/_current/addresses
         */
        getAddressList: (params: RequestParams = {}) =>
            this.request<AddressViewModelListSuccessEnvelop, any>({
                path: `/api/pam/v1/users/_current/addresses`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamV1UsersCurrentAddressesCreate
         * @request POST:/api/pam/v1/users/_current/addresses
         */
        pamV1UsersCurrentAddressesCreate: (
            data: AddAddressRequest,
            query?: {
                ignoreLocationValidation?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<AddressViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/users/_current/addresses`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamLogisticV1UsersCurrentList
         * @request GET:/api/pam/logistic/v1/users/_current
         */
        pamLogisticV1UsersCurrentList: (params: RequestParams = {}) =>
            this.request<GetUserViewModelSuccessEnvelop, void>({
                path: `/api/pam/logistic/v1/users/_current`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamDriverV1UsersCurrentList
         * @request GET:/api/pam/driver/v1/users/_current
         */
        pamDriverV1UsersCurrentList: (params: RequestParams = {}) =>
            this.request<GetUserViewModelSuccessEnvelop, void>({
                path: `/api/pam/driver/v1/users/_current`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamAdminV1UsersList
         * @request GET:/api/pam/admin/v1/users
         */
        pamAdminV1UsersList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                mobile_number?: string
                /** @default "" */
                email_address?: string
                /** @default "" */
                first_name?: string
                /** @default "" */
                last_name?: string
                /** @default "" */
                query?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<GetAdminUserViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/users`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamAdminV1UsersMobileNumberDetail
         * @request GET:/api/pam/admin/v1/users/mobile-number/{mobileNumber}
         */
        pamAdminV1UsersMobileNumberDetail: (mobileNumber: string, params: RequestParams = {}) =>
            this.request<GetAdminUserViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/admin/v1/users/mobile-number/${mobileNumber}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamAdminV1UsersCurrentList
         * @request GET:/api/pam/admin/v1/users/_current
         */
        pamAdminV1UsersCurrentList: (params: RequestParams = {}) =>
            this.request<GetUserViewModelSuccessEnvelop, void>({
                path: `/api/pam/admin/v1/users/_current`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamAdminV1UsersIdRolesUpdate
         * @request PUT:/api/pam/admin/v1/users/id/{id}/roles
         */
        pamAdminV1UsersIdRolesUpdate: (id: string, data: AssignRoleToUserRequest, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/users/id/${id}/roles`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name PamAdminV1UsersIdRoleGroupsUpdate
         * @request PUT:/api/pam/admin/v1/users/id/{id}/role-groups
         */
        pamAdminV1UsersIdRoleGroupsUpdate: (
            id: string,
            data: AssignRoleGroupToUserRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/users/id/${id}/role-groups`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserReferral
         * @name PamV1UsersCurrentReferralCodeList
         * @request GET:/api/pam/v1/users/_current/referral-code
         */
        pamV1UsersCurrentReferralCodeList: (params: RequestParams = {}) =>
            this.request<GetUserReferralCodeViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/pam/v1/users/_current/referral-code`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserReferral
         * @name PamAdminV1UsersReferralBlockedCreate
         * @request POST:/api/pam/admin/v1/users/{id}/referral/blocked
         */
        pamAdminV1UsersReferralBlockedCreate: (id: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/pam/admin/v1/users/${id}/referral/blocked`,
                method: 'POST',
                ...params,
            }),
    }
    internal = {
        /**
         * No description
         *
         * @tags Debug
         * @name DebugUsersIdRefreshStateDetail
         * @request GET:/__internal/debug/users/id/{id}/refresh-state
         */
        debugUsersIdRefreshStateDetail: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/users/id/${id}/refresh-state`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugUsersMobileNumberRefreshStateDetail
         * @request GET:/__internal/debug/users/mobile-number/{mobileNumber}/refresh-state
         */
        debugUsersMobileNumberRefreshStateDetail: (mobileNumber: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/users/mobile-number/${mobileNumber}/refresh-state`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugAppsettingsList
         * @request GET:/__internal/debug/appsettings
         */
        debugAppsettingsList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/appsettings`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugCheckAbTestList
         * @request GET:/__internal/debug/check-ab-test
         */
        debugCheckAbTestList: (
            query: {
                mobile_number: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/check-ab-test`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugKibaHttpClientHandlersList
         * @request GET:/__internal/debug/kiba-http-client-handlers
         */
        debugKibaHttpClientHandlersList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/kiba-http-client-handlers`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugKibaWorkersList
         * @request GET:/__internal/debug/kiba-workers
         */
        debugKibaWorkersList: (
            query?: {
                name?: string
                is_enabled?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/kiba-workers`,
                method: 'GET',
                query: query,
                ...params,
            }),
    }
}
